import { apiGet, apiPost, apiPut, apiDelete } from '../helpers/ApiHelper';
import Auth from 'j-toker';
import { toDate, toISO8601DateString } from 'helpers/Formatter';
import * as notifications from './notificationActions';

export function getVendors() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/vendors`)
        .done(response => {
          dispatch(saveVendors(response.vendors));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

function saveVendors(data) {
  const parsedData = data.map(vendor => {
    if (vendor.insurance_expiry_date) {
      vendor.insurance_expiry_date = toDate(vendor.insurance_expiry_date);
    }

    return vendor;
  });

  return {
    type: 'VENDORS::SAVE_VENDORS',
    vendors: parsedData,
  };
}

export function deleteVendor(vendorId) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/landlords/vendors/${vendorId}`)
        .done(response => {
          dispatch(closeVendorInfoDialog());
          dispatch(notifications.showSuccess('vendorSuccessfullyDeleted'));
          dispatch(getVendors());
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function addVendor(data) {
  if (data.insurance_expiry_date) {
    data.insurance_expiry_date = toISO8601DateString(data.insurance_expiry_date);
  }

  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/landlords/vendors`, data)
        .done(response => {
          dispatch(notifications.showSuccess('vendorSuccessfullyCreated'));
          dispatch(getVendors());
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function putVendor(data, vendorId) {
  if (data.insurance_expiry_date) {
    data.insurance_expiry_date = toISO8601DateString(data.insurance_expiry_date);
  }

  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/vendors/${vendorId}`, data)
        .done(response => {
          dispatch(notifications.showSuccess('vendorSuccessfullyUpdated'));
          dispatch(getVendors());
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getGroupedVendors() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/grouped_vendors`)
        .done(response => {
          dispatch(saveVendorGroup(response.vendors));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function saveVendorGroup(response) {
  const array = response;
  const val = array[array.length - 1];
  return {
    type: 'VENDORS::SAVE_GROUPED_VENDORS',
    vendor: response,
    assignment: val,
  };
}

export function openAddVendorDialog() {
  return {
    type: 'VENDORS::SHOW_ADD_VENDOR_INFO_DIALOG',
    isOpen: true,
  };
}

export function openEditVendorDialog() {
  return {
    type: 'VENDORS::SHOW_EDIT_VENDOR_DIALOG',
    isOpen: true,
  };
}

export function closeAddVendorDialog() {
  return {
    type: 'VENDORS::CLOSE_ADD_VENDOR_INFO_DIALOG',
    isOpen: false,
  };
}

export function openVendorInfoDialog(vendorDetails) {
  return {
    type: 'VENDORS::SHOW_VENDOR_INFO_DIALOG',
    isOpen: true,
    vendorDetails,
  };
}

export function closeVendorInfoDialog() {
  return {
    type: 'VENDORS::CLOSE_VENDOR_INFO_DIALOG',
    isOpen: false,
  };
}
